import { date, showAlert } from '../../../lib/helpers';
import { editedItem, headers, search } from './attributes';
import { dataTransactionType } from '../../../store/params';

export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    switchCh: true,
    isFirstLoad: true,
    options: {},
    dialog: false,
    headers,
    search,
    editedItem,
    selectedRow: '',
    editedIndex: -1,
    filterValue: { trx_date: [] },
    filterConfig: [
      { key: 'trx_date', type: 'daterange', required: true, props: { label: 'Tanggal Transaksi', includeToday: true, limitRangeTo30Days: true } },
    ],
    filterData: [
      { label: 'Agregator Name', field: 'aggregator_name', type: 'text' },
      { label: 'Merchant Name', field: 'merchant_name', type: 'text' },
      { label: 'MID', field: 'mid', type: 'text' },
      { label: 'Transaction Type', field: 'jenis_trx', type: 'select', items: dataTransactionType },
      { label: '', field: 'empty_1', type: '' },
      { label: '', field: 'empty_2', type: '' },
      { label: '', field: 'empty_3', type: '' },
      { label: '', field: 'empty_4', type: '' },
      { label: '', field: 'empty_5', type: '' },
      { label: '', field: 'empty_6', type: '' },
      { label: '', field: 'empty_7', type: '' },
      { label: '', field: 'empty_8', type: '' },
      { label: '', field: 'empty_9', type: '' },
      { label: 'Source of Fund', field: 'sof', type: 'select', items: dataTransactionType },
    ]
  }),

  computed: {
    allData() {
      return this.$store.state.reportEdc.allData;
    },
    detailData() {
      return this.$store.state.reportEdc.item;
    },
    totalData() {
      return this.$store.state.reportEdc.totalData;
    },
    totalPage() {
      return this.$store.state.reportEdc.totalPage;
    },
    loading() {
      return this.$store.state.reportEdc.loading;
    },
    flashError: {
      get() {
        return this.$store.state.reportEdc.flashError;
      },
      set() {
        this.$store.commit('reportEdc/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.reportEdc.flashErrorMessage;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;
      if (this.checkFilterCh) filterCh = this.switchCh ? 'ch' : 'sql';

      return filterCh;
    },
    isCh() {
      return this.checkEnvCh === 'ch';
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('reportEdc/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    switchCh: {
      handler() {
        this.clearSearch();
      },
    },
  },

  methods: {
    updateSearch(newSearch) {
      this.search.trx_date = newSearch.trx_date || [];
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.search.trx_date = newSearch.trx_date || [];
      this.options.page = 1;
      this.getData(); 
    },
    handleSwitch(val) {
      this.switchCh = val;
    },
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    getData() {
      if (this.search.trx_date.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('reportEdc/clearData');
      } else {
        const source = this.checkEnvCh;
        this.$store.commit('reportEdc/setFlashErrorMessage', '');
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('reportEdc/getData', {
            date,
            page,
            itemsPerPage,
            search: this.search,
            source,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    async viewItem(itemId, item) {
      await this.$store
        .dispatch('reportEdc/getDetail', {
          trx_id: itemId,
          date,
          item,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('reportEdc/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.aggregator_name = '';
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.jenis_trx = '';
      this.search.sof = '';
      this.search.trx_date = [];
      this.$nextTick(() => {
        this.$store.commit('reportEdc/clearData');
      });
    },

    handleExport() {
      if (this.isCh) {
        this.exportExcel();
      } else {
        this.exportItem();
      }
    },

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportEdc/clearData');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['trx_datetime'],
          sortDesc: [true],
          search: this.search,
          countData: this.totalData,
          module: 'edc-trx',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
        });
      }
    },
    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportEdc/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('reportEdc/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};